import React from 'react'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { SelectMui } from 'src/components/SelectMui'
import { useSelector } from 'src/utils/store'
import { defaultFulfillmentCenterTypeFilters } from 'src/features/fulfillmentCenterFilters'
import { actions } from '../../ReceivementOverviewListState'
import { actions as appActions } from '../../../state'
import { useReceivement } from 'src/hooks/useReceivement'
import { selectFulfillmentCenters } from 'src/features/selector'

export const FcFilterSelect = () => {
  const dispatch = useDispatch()
  const { supervisorBadge } = useReceivement({ validateSupervisor: true })
  const idFc = useSelector((state) => state.receivementOverviewList.idFc)
  const fulfillmentCenters = useSelector(selectFulfillmentCenters)

  const { register, formState: { errors } } = useForm({
    defaultValues: {
      'fc-filter-select': idFc || '',
    },
  })

  const resolveFcOptions = () =>
    fulfillmentCenters.map((fulfillmentCenter) => ({
      id: fulfillmentCenter.id,
      description: fulfillmentCenter.name,
    }))

  const setSelectedFc = React.useCallback((value: string) => {
    dispatch(actions.updateOverviewFilterField({ key: 'idFc', value }))
  }, [dispatch])

  React.useEffect(() => {
    if (supervisorBadge && fulfillmentCenters.length === 0) {
      dispatch(appActions.getAvailableFulfillmentCenters(defaultFulfillmentCenterTypeFilters))
    }
  }, [dispatch, fulfillmentCenters.length, supervisorBadge])

  return (
    <SelectMui
      label='FC'
      id='fc-filter-select'
      options={resolveFcOptions()}
      value={idFc}
      optionNone={false}
      onChange={(event) => setSelectedFc(event.target.value as string)}
      inputProps={{ ...register('fc-filter-select', { required: 'Campo obrigatório' }) }}
      error={!!errors['fc-filter-select']}
      helperText={errors['fc-filter-select']?.message}
      required
    />
  )
}
